<template>
	<div><!--one root element needed-->
		<div class="form-group" style="display: none">
			<v-input type="text" name="customization" v-model="newOffice.customization" hidden></v-input>
		</div>
		<div v-show="moduleEntreprise == 0" class="form-group"><!--Seuil-->
			<v-input type="number" name="revenueThreshold" class="configInput" v-model="revenueThreshold" title="Seuil chiffre d'affaires (€)"></v-input>
		</div>
		<div v-show="(solo == 1 || office.id === 137) && !taxEnable" class="form-group row" id="TVASwitchContainer"><!--TVA-->
			<label class="col-md-3 col-form-label">
				<span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" data-original-title="Si vous êtes assujettis à la TVA, vous devez activer cette option. (Attention, cette action est irreversible.)">
					<i class="icon-info"></i>
				</span>
				<span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="Si vous êtes assujettis à la TVA, vous devez activer cette option. (Attention, cette action est irreversible.)">
					<i class="icon-info"></i>
				</span>
				Activer la TVA
			</label>
			<div class="col-md-1">
				<input class="switchBtn" id="taxEnableSwitch" type="checkbox" data-on-text="Oui" data-off-text="Non" data-size="mini" v-model="taxEnable">
			</div>
		</div>
		<div v-show="moduleFlyer == 1" class="form-group"><!--Couleur-->
			<span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" data-original-title="Couleur utilisée pour les flyers.">
				<i class="icon-info"></i>
			</span>
			<span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="Couleur utilisée pour les flyers.">
				<i class="icon-info"></i>
			</span>
			<label>Couleur :</label>
			<swatches v-model="color" colors="text-advanced"></swatches>
		</div>
		<div v-show="moduleBureau == 1" class="form-group"><!--Format honoraires-->
			<label>Format des honoraires : </label>
			<div class="mt-radio-inline">
				<label class="mt-radio">
					<input type="radio" name="honorairesType" id="euro" value="euro" v-model="honorairesType" :checked="honorairesType=='euro'">Euro (€)
					<span></span>
				</label>
				<label class="mt-radio">
					<input type="radio" name="honorairesType" id="percent" value="percent" v-model="honorairesType" :checked="honorairesType=='percent'">Pourcentage (%)
					<span></span>
				</label>
				<label class="mt-radio">
					<input type="radio" name="honorairesType" id="both" value="both" v-model="honorairesType" :checked="honorairesType=='both'">Les Deux
					<span></span>
				</label>
			</div>
		</div>
		<div v-if="solo == 1" class="form-group row"><!--Notification RDV SOLO-->
            <!--<label>Notification par mail des RDV :</label>
            <div class="mt-checkbox-inline">
                <label class="mt-checkbox">
                    <input type="checkbox" id="bookingMail" value="permanents" v-model="bookingMailToUser"> Activer
                    <span></span>
                </label>
            </div>-->
        	<label class="col-md-3 col-form-label">
        		<span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" data-original-title="Dès que vous créez, modifiez ou annulez un RDV, vous recevrez un mail avec les informations.">
        			<i class="icon-info"></i>
        		</span>
        		<span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="Dès que vous créez, modifiez ou annulez un RDV, vous recevrez un mail avec les informations.">
        			<i class="icon-info"></i>
        		</span>
        		Notifier les RDV
        	</label>
        	<div class="col-md-1">
        		<input class="switchBtn" id="switchBtnRDVPerm" type="checkbox" data-on-text="Oui" data-off-text="Non" data-size="mini" v-model="bookingMailToPermanents">
        	</div>
		</div>
        <div v-else><!--Is Structure-->
        	<div class="form-group row"><!--Notification RDV Perm Structure-->
        		<label class="col-md-3 col-form-label">
        			<span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" data-original-title="Dès que vous créez, modifiez ou annulez un RDV, le Permanent concerné recevra un mail avec les informations.">
        				<i class="icon-info"></i>
        			</span>
        			<span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="Dès que vous créez, modifiez ou annulez un RDV, le Permanent concerné recevra un mail avec les informations.">
        				<i class="icon-info"></i>
        			</span>
        			Notifier les RDV des Permanents
        		</label>
        		<div class="col-md-1">
        			<input class="switchBtn" id="switchBtnRDVPerm" type="checkbox" data-on-text="Oui" data-off-text="Non" data-size="mini" v-model="bookingMailToPermanents">
        		</div>
        	</div>
        	<div class="form-group row"><!--Notification RDV Renf Structure-->
        		<label class="col-md-3 col-form-label">
        			<span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" data-original-title="Dès que vous créez, modifiez ou annulez un RDV, le Renfort concerné recevra un mail avec les informations.">
        				<i class="icon-info"></i>
        			</span>
        			<span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="Dès que vous créez, modifiez ou annulez un RDV, le Renfort concerné recevra un mail avec les informations.">
        				<i class="icon-info"></i>
        			</span>
        			Notifier les RDV des Renforts
        		</label>
        		<div class="col-md-1">
        			<input class="switchBtn" id="switchBtnRDVRenf" type="checkbox" data-on-text="Oui" data-off-text="Non" data-size="mini" v-model="bookingMailToRenforts">
        		</div>
        	</div>
            	<!--<label>Notification par mail des RDV :</label>
                <div class="mt-checkbox-inline">
                    <label class="mt-checkbox">
                        <input type="checkbox" id="bookingMail" value="permanents" v-model="bookingMailToUser">Permanents
                        <span></span>
                    </label>
                    <label class="mt-checkbox">
                        <input type="checkbox" id="bookingMail" value="renforts" v-model="bookingMailToUser">Renforts
                        <span></span>
                    </label>
                </div>
            </div>
            <div class="form-group">
            	<label for="emailCopy">Entrez une adresse mail pour recevoir, sur cette adresse, une copie des mails envoyés :</label>
                <div class="input-group">
                	<span class="input-group-addon"><i class="far fa-envelope" style="color:black"></i></span>
                	<input id="emailCopy" type="email" class="form-control" name="emailCopy" v-model="emailCopy" placeholder="Adresse email">
                </div>
            </div>-->
        </div>
        <div class="form-group row"><!--Copie mail-->
        	<label class="col-md-3 col-form-label">
        		<span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" :data-original-title="copyMailTooltip">
        			<i class="icon-info"></i>
        		</span>
        		<span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" :data-original-title="copyMailTooltip">
        			<i class="icon-info"></i>
        		</span>
        		Activer la copie des mails
        	</label>
        	<div class="col-md-1">
        		<input class="switchBtn" id="switchBtnCopie" type="checkbox" data-on-text="Oui" data-off-text="Non" data-size="mini" v-model="emailCopyEnable">
        	</div>
        	<div class="input-group col-md-4" v-show="emailCopyEnable">
        		<input id="emailCopy" type="email" class="form-control" name="emailCopy" v-model="emailCopy" placeholder="Adresse email">
        	</div>
        </div>
        <div class="form-group row"><!--Planning lendemain-->
        	<label class="col-md-3 col-form-label">
        		<span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" data-original-title="Vous recevrez tous les jours à 20h00 le planning du lendemain sur cette adresse.">
        			<i class="icon-info"></i>
        		</span>
        		<span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="Vous recevrez tous les jours à 20h00 le planning du lendemain sur cette adresse.">
        			<i class="icon-info"></i>
        		</span>
        		Planning du lendemain
        	</label>
        	<div class="col-md-1">
        		<input class="switchBtn" id="switchBtnNextDay" type="checkbox" data-on-text="Oui" data-off-text="Non" data-size="mini" v-model="nextDayAppointmentsEnable">
        	</div>
        	<div class="input-group col-md-4" v-show="nextDayAppointmentsEnable">
        		<input id="emailNextDayAppointments" type="email" class="form-control" name="emailNextDayAppointments" v-model="emailNextDayAppointments" placeholder="Adresse email">
        	</div>
        </div>

        <div class="form-group">
        	<button type="submit" class="btn green" @click="check()">Valider la configuration</button>
        </div>
        <!-------------------TVA Confirmation modal------------------------>
        <div id="TVAConfirm" class="modal fade" role="dialog">
        	<div class="modal-dialog" role="document">
        		<div class="modal-content" style="border-radius: 6px !important">
        			<div class="modal-header">
        				<button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
        				<h4 class="modal-title" id="ModalLabel">TVA</h4>
        			</div>
        			<div class="modal-body" style="padding: 15px;">
        				<p>Cette action est irréversible êtes-vous sûr de vouloir activer la TVA ?</p>
        			</div>
        			<div class="modal-footer">
        				<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="cancelTVA()">Annuler</button>
        				<button type="button" class="btn green" id="validateTVAConfirm" data-dismiss="modal" @click="send()">Confirmer</button>
        			</div>
        		</div>
        	</div>
        </div>
    </div>
</template>

<script>
import Swatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";

export default {
	name: 'OfficeCustomizationForm',
	props: {
		office: {
		    type: Object,
		    default: () => ({})
		},
		moduleBureau:{
			type: Number,
            default: false
		},
		moduleEntreprise:{
			type: Number,
            default: 0
		},
		moduleFlyer:{
			type: Number,
            default: 0
		},
		solo:{
			type: Number,
            default: false
		}
	},
	components: { Swatches },
	data () {
		return {
			newOffice: this.office,
			revenueThreshold: this.office.customization?.revenueThreshold || '',
			taxEnable: this.office.customization?.taxEnable || '',
			honorairesType: this.office.customization?.honorairesType || 'percent',
			color: this.office.customization?.color || '#043a46',
			bookingMailToPermanents: this.office.customization?.bookingMailToUser && this.office.customization.bookingMailToUser.includes('permanents'),
			bookingMailToRenforts: this.office.customization?.bookingMailToUser && this.office.customization.bookingMailToUser.includes('renforts'),
			emailCopyEnable: !!this.office.customization?.emailCopy,
			emailCopy: this.office.customization?.emailCopy || '',
			nextDayAppointmentsEnable: !!this.office.customization?.emailNextDayAppointments,
			emailNextDayAppointments: this.office.customization?.emailNextDayAppointments || '',
		}
	},
	mounted() {
		$(".switchBtn").bootstrapSwitch();
		$("#switchBtnRDVPerm").bootstrapSwitch();
		$("#switchBtnRDVRenf").bootstrapSwitch();

		// switch doesn't trigger vue update so force update here
		let vue_instance = this
		$('#switchBtnCopie').on('switchChange.bootstrapSwitch', function(event, state) {
			vue_instance.emailCopyEnable = state
		})
		$('#switchBtnNextDay').on('switchChange.bootstrapSwitch', function(event, state) {
			vue_instance.nextDayAppointmentsEnable = state
		})
	},
	computed: {
		copyMailTooltip:function(){
			let msg = 'Dès que vous envoyez un mail à un client ';

			if (this.solo != 1) {
				msg += 'ou à un prestataire de votre structure (mailing, facture, honoraire, confirmation de paiement en ligne ou devis)'
			} else {
				msg += '(mailing, facture, devis ou confirmation de paiement en ligne)'
			}

			msg +=' vous recevrez une copie sur cette adresse.'

			return msg
		}
	},
	methods: {
		check(){
			if (!this.taxEnable && $("#taxEnableSwitch").bootstrapSwitch('state')) { // desactivate before and now activate
				$("#TVAConfirm").modal('show')
			} else {
				this.send()
			}
		},
		cancelTVA(){
			$("#taxEnableSwitch").bootstrapSwitch('state', false, true);
		},
		async send() {
			$("#TVAConfirm").modal('hide')
			let err = false

			if (this.revenueThreshold != "" && !$.isNumeric(this.revenueThreshold)) {
				this.$snotify.error("Le seuil chiffre d'affaires doit être un nombre", { timeout:5000 })
				err = true
			}

			if (this.emailCopyEnable && this.emailCopy == "") {
				this.$snotify.error("Si vous souhaitez recevoir une copie des mail envoyés, veuillez rentrer un mail destinataire sinon désactivez l'option.",{
					timeout:5000
				})
				err = true
			}

			if (this.nextDayAppointmentsEnable && this.emailNextDayAppointments == "") {
				this.$snotify.error("Si vous souhaitez recevoir le planning du lendemain, veuillez rentrer un mail destinataire, sinon désactivez l'option.",{
					timeout:5000
				})
				err = true
			}

			if (!err) {
				let bookingMailToUser = [];
				if($("#switchBtnRDVPerm").bootstrapSwitch('state')) {
					bookingMailToUser.push("permanents")
				}

				if($("#switchBtnRDVRenf").bootstrapSwitch('state')) {
					bookingMailToUser.push("renforts")
				}

				if(!this.emailCopyEnable) {
					this.emailCopy = ""
				}

				if(!this.nextDayAppointmentsEnable) {
					this.emailNextDayAppointments = ""
				}

				let val = {
                  revenueThreshold: parseFloat(this.revenueThreshold),
                  taxEnable: $("#taxEnableSwitch").bootstrapSwitch('state'),
                  honorairesType: this.honorairesType,"color":this.color,
                  bookingMailToUser: bookingMailToUser,
                  emailCopy: this.emailCopy,
                  emailNextDayAppointments: this.emailNextDayAppointments
                }

				await axios.put(`/office/${this.office.id}/customization`, val).then(response =>{
					if(response.data.updated){
						this.$snotify.success('Configuration mise à jour')
						if(!this.taxEnable && $("#taxEnableSwitch").bootstrapSwitch('state')){
							$("#TVASwitchContainer").hide()
							this.taxEnable=true
						}
					}
				})
			}
		}
	}
};

</script>
